import auth from './auth';

export default {
  namespaced: true,
  modules: {
    auth,
  },
};
